import { useIsEmbeddedMobileLayout } from 'features/embeddedSidebar/hooks/useIsEmbeddedMobileLayout'
import { useEffect } from 'react'

export interface UseFloatingDocumentPreviewParams {
  preferOverlay?: boolean
  isActive: boolean
  isOpen: boolean
  /** What happens to an open preview when its tab is backgrounded. */
  onInactive: 'keep' | 'close'
  onClose: () => void
}

interface FloatingDocumentPreview {
  usesFloatingPreview: boolean
  showFloatingPreview: boolean
}

/**
 * Mount policy for FloatingDocumentPreviewOverlay. The overlay portals to the
 * body, so a backgrounded tab's keep-alive styling cannot hide it: it renders
 * only while the tab is active.
 */
export function useFloatingDocumentPreview({
  preferOverlay = false,
  isActive,
  isOpen,
  onInactive,
  onClose,
}: UseFloatingDocumentPreviewParams): FloatingDocumentPreview {
  const isEmbeddedMobile = useIsEmbeddedMobileLayout()
  const usesFloatingPreview = isEmbeddedMobile || preferOverlay

  useEffect(() => {
    if (!usesFloatingPreview || onInactive !== 'close') return
    if (!isActive && isOpen) onClose()
  }, [isActive, isOpen, onClose, onInactive, usesFloatingPreview])

  return {
    usesFloatingPreview,
    showFloatingPreview: usesFloatingPreview && isOpen && isActive,
  }
}
